import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const INCREMENT_LOADING = "@ui/INCREMENT_LOADING";
export const DECREMENT_LOADING = "@ui/DECREMENT_LOADING";
export const RESET_LOADING = "@ui/RESET_LOADING";

export const UiActions = {
  incrementLoading: () => createAction(INCREMENT_LOADING),
  decrementLoading: () => createAction(DECREMENT_LOADING),
  resetLoading: () => createAction(RESET_LOADING),
};

export type UiActions = ActionsUnion<typeof UiActions>;
